module.exports = {"TXTWCL_Claim_your_bonus":{"id":"TXTWCL_Claim_your_bonus","defaultMessage":"Bónusz megszerzése","track":"Claim your bonus"}}